module.exports = __webpack_public_path__ + "img/grade6.87d0b37d.jpg";